import { Fetch } from 'barnyard/utils/';
import * as constants from '../constants';
import { startSubmit, stopSubmit, reset } from 'redux-form';
import { addNotification } from '~/app/common/packages/notifications';


export const profileUpdate = ({ form, success_notification = false } = {}) => (dispatch, getState) => Fetch({
  url: '/api/accounts/profile/',
  method: 'PATCH',
  body: form,
  before: (json) => {
    dispatch(startSubmit('profile'));
    dispatch({
      type: constants.PROFILE_UPDATE_REQUEST
    });
  },
  success: (json) => {
    dispatch({
      type: constants.PROFILE_UPDATE_SUCCESS,
      entity: json
    });
    dispatch(
      stopSubmit('profile')
    );
    if (success_notification) {
      dispatch(
        addNotification({
          value: 'Successfully updated profile'
        })
      );
    }
  },
  failure: (error) => {
    dispatch(stopSubmit('profile', { _error: 'Error updating profile' }));
  }
});

export const profilePasswordUpdate = (profileId, body) => (dispatch) => {
  const formName = `passwordUpdateForm-${profileId}`;
  return Fetch({
    url: '/api/accounts/password/',
    method: 'PATCH',
    body,
    before: (json) => {
      dispatch(startSubmit(formName));
    },
    success: (json) => {
      dispatch(stopSubmit(formName));
      dispatch(reset(formName));
      dispatch(
        addNotification({
          value: 'Your password has been updated'
        })
      );
    },
    failure: (error) => {
      dispatch(stopSubmit(formName, { _error: 'Error updating password', ...error }));
    }
  });
};

export const profileEmailUpdate = (profileId, body) => (dispatch) => {
  const formName = `emailUpdateForm-${profileId}`;
  return Fetch({
    url: '/api/accounts/email/',
    method: 'PATCH',
    body,
    before: (json) => {
      dispatch(startSubmit(formName));
    },
    success: (json) => {
      dispatch(stopSubmit(formName));
      dispatch(reset(formName));
      dispatch(
        addNotification({
          value: 'Your email has been updated. You will now use this email for logging in'
        })
      );
      dispatch({
        type: constants.PROFILE_UPDATE_SUCCESS,
        entity: json
      });
    },
    failure: (error) => {
      dispatch(stopSubmit(formName, {
        _error: 'Error updating email',
        ...error
      }));
    }
  });
};
